import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Portaluser} from 'src/app/_model/portaluser';
import { PortaluserService } from 'src/app/_services/portaluser.service';
import { PortalUserRequest } from 'src/app/_model/request/PortalUserRequest';
import { ToastrService } from 'ngx-toastr';
import {DialogCloseData} from '../../_model/models';
import {DIALOG_OPERATIONS} from "../../_utils/constants";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-portaluser-delete',
  templateUrl: './portaluser-delete.component.html',
  styleUrls: ['./portaluser-delete.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class PortaluserDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PortaluserDeleteComponent>,
    private portaluserService: PortaluserService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: PortalUserRequest,
    private toastr: ToastrService) { }

  ngOnInit() {
  }
    /*closeModal() {
        this.dialogRef.close();
    }*/
  deleteEmployee(portaluser: PortalUserRequest) {
    this.portaluserService.deleteUser(portaluser).subscribe(result => {
        this.toastr.success('Silme işlemi başarılı', '');
        this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.DELETE, portaluser.id));
    }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
    });
}
}
